module.exports = __webpack_public_path__ + "static/media/Working Remotely During Covid-19 - User Study.be1a2221.png";